export const NavScroll = (function () {
	'use strict';

	let ticking = false;
	let lastScrollPos = 0;
	let serviceMenuOffset;

	function init() {
		navScroll();
		// smoothScroll();
	}

	function navScroll() {
		// check if inner-page/service menu exists
		if (document.querySelector('.menu-services')) {
			serviceMenuOffset = document.querySelector('.menu-services').offsetTop;
		}

		window.addEventListener('scroll', function () {
			lastScrollPos = window.scrollY;

			var menuServices = document.querySelector('.menu-services');

			if (!ticking) {
				window.requestAnimationFrame(function () {
					if (lastScrollPos > 75) {
						document.body.classList.add('page-scrolled');
					} else {
						document.body.classList.remove('page-scrolled');
					}

					if (menuServices) {
						if (lastScrollPos > serviceMenuOffset) {
							menuServices.classList.add('sticky');
							document.body.classList.add('sub-nav-sticky');
							// gumshoe.setDistances();
						} else {
							document.body.classList.remove('sub-nav-sticky');
							menuServices.classList.remove('sticky');
						}
					}
					ticking = false;
				});
			}
			ticking = true;
		});
	};

	function smoothScroll() {
		// Apply smoothscroll to all links with class 'smooth-scroll
		var scroll = new SmoothScroll('.smooth-scroll', {
			header: '.banner',
			offset: 58
		});

		gumshoe.init({ offset: 80 });
	}

	return {
		init: init,
	};
})();
